import React from "react";
import "../../../../Utils/Css/Menu.css";

export default function Menu() {
  return (
    <header className="menuContainer primary white">
      <div className="menuIcon"></div>
      <div className="menuExchange">EXCH</div>
      <div className="menuSymbol addFlex">SYMBOL</div>
      <div className="menuExpiry">EXPIRY</div>
      <div className="menuBuyPrice addFlex">BUY PRICE</div>
      {/* <div className="menuBuyQty">BUY QTY</div> */}
      <div className="menuSellPrice addFlex">SELL PRICE</div>
      {/* <div className="menuSellQty">SELL QTY</div> */}
      <div className="menuLtp addFlex">LTP</div>
      <div className="menuNetChange addFlex">NET CHANGE</div>
      <div className="menuOpen">OPEN</div>
      <div className="menuHigh">HIGH</div>
      <div className="menuLow">LOW</div>
      <div className="menuClose">CLOSE</div>
      <div className="menuLtt addFlex">LTT/LUT</div>
    </header>
  );
}
